module.exports = __webpack_public_path__ + "img/logo-company.8e0e7546.png";